export const CommonLang = {

  LUTON_CERAMIC: 'Luton Ceramic Pvt. Ltd.',
  PAGE_NOT_FOUND: 'Page Not Found',
  BACK_TO_HOME: "Back to Home",
  SOMETHING_WENT_WORNG:"Oops! The page you're looking for doesn't exist. It might have been moved, deleted, or you entered the wrong URL.",

};

